import { Component, Input, inject } from '@angular/core';

import { LayoutService } from '@components/layout/layout.service';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
  standalone: false,
})
export class StepsComponent {
  layoutService = inject(LayoutService);

  @Input() steps: Array<string>;
  @Input() currentStep: number;
}
